<template>
  <div class="features" v-if="product && product.feature">
    <h3 class="detail-info-title">Features</h3>
    <ul class="features-list">
      <li v-for="(feature, index) of product.feature" :key="index" class="features-list-item">
        {{ feature }}
      </li>
    </ul>
  </div>
</template>

<script>
import Divider from './Divider.vue';

export default {
  name: 'ProductFeature',
  components: {
    Divider,
  },
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.features {
  .features-list {
    list-style-type: disc;
    margin-left: var(--space-5);

    .features-list-item {
      display: list-item;
    }
  }
}
</style>
